class navbarHelper {
    constructor() {
        const toggles = Array.from(document.querySelectorAll('[data-toggle="navbar-search"]')),
            searchEl = document.getElementById('navbar-search'),
            searchInput = document.getElementById('navbar-search-input');
        toggles.forEach((toggle, i) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                if (searchEl.classList.contains('show')) {
                    searchEl.classList.remove('show');
                } else {
                    searchEl.classList.add('show');
                    setTimeout(() => {
                        searchInput.focus();
                    }, 200);
                }
            });
        });

        this.showCloseOverlayOnNavbarToggle();
        this.initRequestsIcon();
    }

    initRequestsIcon() {
        let storage = localStorage.getItem('tooling-catalog-state');
        catalogState = storage ? JSON.parse(storage) : {};
        if (catalogState.requests) {
            this.updateRequestsIconAmount(catalogState.requests.length);
            window.addEventListener('storage-updated', (e) => {
                let currentStorage = JSON.parse(window.localStorage.getItem('tooling-catalog-state'));
                this.updateRequestsIconAmount(currentStorage.requests.length);
            }, false);
        }
    }

    updateRequestsIconAmount(num) {

        if (num > 0) {
            $('#request-header-icon').find('span').addClass('show');
            $('#request-header-icon').find('span').text(num);
        } else {
            $('#request-header-icon').find('span').removeClass('show');
        }
    }

    showCloseOverlayOnNavbarToggle() {
        const collapse = $('#navbarCollapse'),
            backdrop = $('#navbar-backdrop');
        backdrop.on('click', function (e) {
            collapse.collapse('hide');
        });
        collapse.on('shown.bs.collapse', function () {
            backdrop.addClass('show');
        });
        collapse.on('hide.bs.collapse', function () {
            backdrop.removeClass('show');
        });
    }
}
window.app.add('navbar', new navbarHelper());
